import { createApp } from "vue";
import App from "@/App.vue";
import router from "@/router";
import jquery from "jquery";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import locale from "element-plus/lib/locale/lang/zh-cn";
import "@/assets/css/BaoUi.css";
import "@/assets/css/main.css";
import VueClipboard from "vue-clipboard2";
import store from "@/store/index";
import emojiList from "@/utils/emoji";
import VirtualScrollbar from "@/components/VirtualScrollbar.vue";
import TouchTheBottom from "@/components/TouchTheBottom.vue";
import EmojiNew from "@/components/EmojiNew.vue";
import UploadImages from "@/components/UploadImages.vue";
import LateralScrolling from "@/components/LateralScrolling.vue";
// import * as ElIconList from "../n/element-plus/icons";
import * as ElIconList from "../node_modules/@element-plus/icons-vue";
const app = createApp(App);
app.component("VirtualScrollbar", VirtualScrollbar);
app.component("TouchTheBottom", TouchTheBottom);
app.component("EmojiNew", EmojiNew);
app.component("UploadImages", UploadImages);
app.component("LateralScrolling", LateralScrolling);
for (const name in ElIconList) {
  app.component(name, ElIconList[name]);
}
const OSS = require("ali-oss");
// const addEventListenerCopy = () => {
//   document.addEventListener("DOMContentLoaded", function () {
// // const pasteArea = document.getElementById("pasteArea");
// // const resultContainer = document.getElementById("resultContainer");
// // const typeBadge = document.getElementById("typeBadge");
// // const contentResult = document.getElementById("contentResult");
// // const tryAgain = document.getElementById("tryAgain");

//     // 监听粘贴事件
//     document.addEventListener("paste", function (e) {
//       // 阻止默认粘贴行为
//       e.preventDefault();

//       // 获取剪贴板数据
//       const clipboardData = e.clipboardData || window.clipboardData;
//       if (!clipboardData) {
//         // showResult("unknown", "无法访问剪贴板数据");
//         this.$message.error("无法访问剪贴板数据");
//         return;
//       }

//       // 检查是否有文本内容
//       if (clipboardData.types.includes("text/plain")) {
//         const textContent = clipboardData.getData("text/plain");
//         // showResult("text", textContent);
//         console.error("====检测到粘贴====文本", textContent);
//       }
//       // 检查是否有图片
//       else if (clipboardData.items) {
//         for (let i = 0; i < clipboardData.items.length; i++) {
//           if (clipboardData.items[i].type.indexOf("image") !== -1) {
//             const blob = clipboardData.items[i].getAsFile();
//             const imageUrl = URL.createObjectURL(blob);
//             // showResult("image", imageUrl);
//             console.error("====检测到粘贴====图片", imageUrl);
//             return;
//           }
//         }
//         // showResult("unknown", "剪贴板中没有检测到文本或图片内容");
//       } else {
//         // showResult("unknown", "无法识别剪贴板内容类型");
//       }
//     });
//   });
// };
// app.config.globalProperties.$addEventListenerCopy = addEventListenerCopy;
const companyIdArr = [
  {
    name: "V策财经",
    companyId: 0,
  },
  {
    name: "正信期货",
    companyId: 1,
  },
  {
    name: "新湖期货",
    companyId: 4,
  },
  {
    name: "东海期货",
    companyId: 6,
  },
];
router.beforeEach((to, from, next) => {
  // console.warn("router", router.options.routes);
  document.title = `${to.meta.title}`;
  const routes = router.options.routes;
  const role = localStorage.getItem("vce-token-push");
  // const isCompany = localStorage.getItem("is_company") * 1; // 判断是否为期货公司
  const companyId = localStorage.getItem("company_id") * 1; // 期货公司id
  // const vceUrls = [
  //   "/chat",
  //   "/statistics",
  //   "/businessDynamic",
  //   "/articleTemplate",
  //   "/marketEditor",
  //   "/pushMessage",
  //   "/bbas",
  //   "/headlineReport",
  //   "/viewingData",
  //   "/qiyouCommunity",
  //   "/blackResearchReport",
  //   "/qihuoshangpin",
  //   "/liveAssistant",
  // ]; // V策财经专属路由

  // const zhengxinUrls = ["/bandOpportunity"]; // 1正信专属路由

  // const xinhuUrls = ["/varietyTracking"]; // 4新湖专属路由

  // const donghaiUrls = [
  //   "/shortStrategy",
  //   "/trendFollowingList",
  //   "/trendFollowing",
  // ]; // 6东海专属路由
  // let nextUrl = "";
  if (!role && to.path !== "/login") {
    // 未登录访问非登录页
    next("/login");
    // nextUrl = "/login";
  } else {
    // for (const item of routes) {
    //   console.warn("to.path", routes);
    //   if (to.path == item.path) {
    //     if (companyId != undefined && item.companyIds.includes(companyId)) {
    //       console.log("可以访问A", to.path);
    //       next();
    //       return;
    //       // nextUrl = "";
    //     } else {
    //       console.error("非法访问A", to.path);
    //       next("/404");
    //       return;
    //       // nextUrl = "/404";
    //     }
    //   }
    // }

    // for (const item of routes[1].children) {
    //   if (to.path == item.path) {
    //     if (item.companyIds.includes(companyId)) {
    //       console.log("可以访问B", to.path);
    //       next();
    //       return;
    // // nextUrl = "";
    //     } else {
    //       console.error("非法访问B", to.path);
    //       next("/404");
    //       return;
    //       // nextUrl = "/404";
    //     }
    //   }
    // }

    // const matchedArr = to.matched.map((item) => item.path);
    // if (matchedArr.includes("/:pathMatch(.*)*")) {
    //   // 如果路由不匹配任何路由记录
    //   next("/404"); // 重定向到404页面
    // // nextUrl = "/404";
    // }

    // console.log("routes", routes[1].children);
    // if (
    //   (isCompany == 1 && vceUrls.includes(to.path)) ||
    //   (companyId != 1 && zhengxinUrls.includes(to.path)) ||
    //   (companyId != 4 && xinhuUrls.includes(to.path)) ||
    //   (companyId != 5 && companyId != 6 && donghaiUrls.includes(to.path))
    // ) {
    //   next("/404");
    // } else {
    next();
    // }
  }
  // next(nextUrl);
});

app.mixin({
  data() {
    return {
      testMixin: 666,
    };
  },
  mounted() {
    // console.error("=====我出现了");
  },
  methods: {
    // 挂载监听粘贴事件到指定节点
    addEventListenerCopy(id) {
      const that = this;
      // console.error("=====挂载监听", id);
      const pasteTarget = document.getElementById(id);
      // 监听粘贴事件
      pasteTarget.addEventListener("paste", function (e) {
        // 阻止默认粘贴行为
        e.preventDefault();

        // 获取剪贴板数据
        const clipboardData = e.clipboardData || window.clipboardData;
        if (!clipboardData) {
          // showResult("unknown", "无法访问剪贴板数据");
          this.$message.error("无法访问剪贴板数据");
          return;
        }

        // 检查是否有文本内容
        if (clipboardData.types.includes("text/plain")) {
          const textContent = clipboardData.getData("text/plain");
          // showResult("text", textContent);
          // console.error("====检测到粘贴====文本", textContent);
          that.handleAddEventListenerCopy({
            type: "text",
            data: textContent,
            origin: id,
          });
        }
        // 检查是否有图片
        else if (clipboardData.items) {
          for (let i = 0; i < clipboardData.items.length; i++) {
            if (clipboardData.items[i].type.indexOf("image") !== -1) {
              const blob = clipboardData.items[i].getAsFile();
              const imageUrl = URL.createObjectURL(blob);
              // showResult("image", imageUrl);
              // console.error("====检测到粘贴====图片", imageUrl);
              that.handleAddEventListenerCopy({
                type: "img",
                data: imageUrl,
                origin: id,
              });
              return;
            }
          }
          // showResult("unknown", "剪贴板中没有检测到文本或图片内容");
        } else {
          // showResult("unknown", "无法识别剪贴板内容类型");
        }
      });
    },
    // 获取图片名称
    getFileName(file) {
      var d = new Date();
      var year = d.getFullYear();
      var month =
        d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      var date = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      var type = file.type.substr(
        file.type.lastIndexOf("/") + 1,
        file.type.length
      );
      return (
        "push/chat/" +
        year +
        month +
        date +
        "/" +
        Math.round(new Date()) +
        "." +
        type
      );
    },
    uploadImgToOSS(e) {
      return new Promise((resolve, reject) => {
        let client = new OSS({
          // region以杭州为例（oss-cn-hangzhou），其他region按实际情况填写。
          region: "oss-cn-shanghai",
          // 阿里云主账号AccessKey拥有所有API的访问权限，风险很高。强烈建议您创建并使用RAM账号进行API访问或日常运维，请登录RAM控制台创建RAM账号。
          accessKeyId: "LTAI5tRozUZ3WynSFfTzC72S",
          accessKeySecret: "HGfPDLd6zylQVVU7c9tkQT7uGKpRd7",
          bucket: "i-vce",
        });
        var name = this.getFileName(e);
        client
          .put(name, e)
          .then(function (res) {
            // 上传图片，返回结果，将图片插入到编辑器中
            resolve(res.url);
          })
          .catch(function (err) {
            console.log(err);
          });
      });
    },
    // 替换内容中的emoji字符
    emojiReplace(str, isDeal) {
      for (const item of emojiList) {
        str = str.replace(
          new RegExp(item.regexp, "g"),
          `<img style="width: 18px !important;height: 18px;vertical-align: sub;" src="${item.url}" />`
        );
      }
      if (isDeal) {
        if (str.includes("<img") && !str.includes("emoji_")) {
          str = "[图片]";
        }
      }

      return str;
    },
  },
});

app
  .use(router)
  .use(jquery)
  .use(store)
  .use(ElementPlus, { locale })
  .use(VueClipboard)
  .mount("#app");
